import React from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import PropTypes from 'prop-types';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CardContainer from '../../../../../components/kea/CardContainer';
import { linkToQueryDetail } from '../../../../../util/appUtils';
import { generateAndDownloadCSV } from '../components/analyticsCsv';

const MainSection = ({ lostOpportunities, currentShop }) => {
  const localizeMessage = useLocalizedMessage();
  const { isFetching, data, error } = lostOpportunities;

  const headCells = [
    {
      id: 'query', numeric: false, label: localizeMessage('analytics.table.query'), sortKey: 'queryText',
    },
    { id: 'users', numeric: true, label: localizeMessage('analytics.table.users') },
    { id: 'total', numeric: true, label: localizeMessage('analytics.table.total') },
  ];

  const prepareRows = (rows) => rows.map((e, i) => ({
    ...e,
    id: `${e.query}-${i}`,
    queryText: e.query,
    query: linkToQueryDetail(currentShop, e.query),
  }));

  return (
    <CardContainer
      error={error}
      isFetching={isFetching}
      headerId="search.analytics.lostOpportunities.header"
      subheaderId="search.analytics.lostOpportunities.subheader"
      styleName="noMargin"
      tableSurface
      actionComponent={(
        <Grid item xs={12} sm={6} md={6} lg={12}>
          <Button startIcon={<CloudDownloadIcon />} onClick={() => generateAndDownloadCSV(headCells, data)}>{localizeMessage('analytics.downloadCsv')}</Button>
        </Grid>
)}
    >
      <AnalyticTable
        rows={prepareRows(data)}
        headCells={headCells}
        orderById="total"
      />

    </CardContainer>
  );
};

MainSection.propTypes = {
  lostOpportunities: PropTypes.shape({
    error: PropTypes.any,
    isFetched: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    data: PropTypes.array,
  }).isRequired,
  currentShop: PropTypes.string.isRequired,
};

export default MainSection;
